<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col cols="12">
                <h1>Report System Fault</h1>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12">
                <b-card>
                    <div slot="header">
                        <strong>Fault details</strong>
                    </div>
                    <div class="form-container">
                        <h4>Please provide as much detail as possible when reporting a system fault.</h4>
                        <b-row class="mt-5">
                            <b-col md="4" sm="6">
                                <b-form-group>
                                    <label for="fullName">Name</label>
                                    <b-form-input v-model="userObj.fullname" type="text" id="fullName" disabled></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col md="4" sm="6">
                                <b-form-group>
                                    <label for="email">Email Address</label>
                                    <b-form-input v-model="userObj.email" type="text" id="email" disabled></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col md="4" sm="12">
                                <b-form-group>
                                    <label for="page">System Page</label>
                                    <b-form-input v-model="faultData.faultPage" type="text" id="page"></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="12">
                                <label for="description">Fault Description</label>
                                <b-form-textarea
                                    id="description"
                                    v-model="faultData.description"
                                    rows="3"
                                    max-rows="6"
                                    :disabled=false
                                ></b-form-textarea>
                            </b-col>
                        </b-row>
                        <hr />
                        <b-row>
                            <b-col cols="12" sm="12" md="12">
                                <p class="action-button-toolbar">
                                    <b-button v-on:click="sendFault" variant="primary" :disabled="saveInProgress">
                                        <i class="fa fa-check"></i>&nbsp;Send Report
                                    </b-button>
                                </p>
                                <b-alert v-if="saveSuccess" variant="success" show><strong>Report sent successfully.</strong></b-alert>
                                <b-alert v-if="saveError" variant="danger" show><strong>Error sending report. Please try again.</strong></b-alert>
                                <b-alert v-if="saveInProgress" variant="info" show><strong>Sending report. Please wait...</strong></b-alert>
                            </b-col>
                        </b-row>
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>

import {appConfig} from '../../shared/app-config';

const getHTTPHeaders = () => {
    let userObj = JSON.parse(localStorage.getItem('user'));
    let headerConfig = {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'Authorization': 'Bearer ' + userObj.token,
        }
    }
    return headerConfig;
}

export default {
  name: 'faults',
  data () {
    return {
        faultData: {
            name: '',
            email: '',
            faultPage: '',
            description: ''
        },
        userObj: {},
        saveSuccess: false,
        saveError: false,
        saveInProgress: false
    }
  },
  created () {
      // grab the settings
      this.getCurrentUser()
        .then((userObj) => {
            userObj.fullname = userObj.first_name + ' ' + userObj.last_name;
            this.$data.userObj = userObj;
        })
  },
  methods : {
    getCurrentUser () {
        return new Promise((resolve, reject) => {
            let user = JSON.parse(localStorage.getItem('user'));
            if (user != null) {
                resolve(user);
            }
            else {
                reject();
            }
        });
    },
    sendFault() {
        this.$data.saveInProgress = true;
        let headersObj = getHTTPHeaders();

        const body = {
          // emailDestination: "michael.wilkinson@planetwidecity.com",
	        sysPage: this.$data.faultData.faultPage,
	        fault: this.$data.faultData.description
        };

        // this.$http.post(appConfig.getEmailEndpoint(), body, headersObj)
        this.$http.post('mail/fault', body, headersObj)
        .then((response) => {
            console.log(response);
            if (response.data.success) {
                this.$data.saveInProgress = false;
                this.$data.saveSuccess = true;
            }
            else {
                this.$data.saveInProgress = false;
                this.$data.saveSuccess = false;
                this.$data.saveError = true;
            }
        })
        .catch ((err) => {
            console.error(err);
            this.$data.saveInProgress = false;
            this.$data.saveSuccess = false;
            this.$data.saveError = true;
        });
    }
  }
}
</script>
